import { ChangeEventHandler, ReactNode, useRef } from 'react'

import { Button, ButtonProps, FormControl, FormLabel } from '@chakra-ui/react'

type Props = ButtonProps & {
  name: string
  acceptedFileTypes?: string
  children?: ReactNode
  onFileChange?: ChangeEventHandler<HTMLInputElement>
  isLoading?: boolean
  className?: string
  id?: string
  inputProps?: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >
  inputRef?: React.RefObject<HTMLInputElement> | null
}

const FileUploader = ({
  name,
  acceptedFileTypes = '',
  children,
  onFileChange,
  isLoading,
  className,
  id = 'writeUpFile',
  inputProps,
  inputRef = null,
  ...props
}: Props) => {
  const fallbackRef = useRef<HTMLInputElement>(null)

  const inputRefValue = inputRef || fallbackRef
  return (
    <FormControl width="auto">
      <FormLabel display={'inline'} m={0} htmlFor={id}>
        <Button
          cursor={'pointer'}
          variant={'brand-solid-white'}
          rounded={'1.25rem'}
          isLoading={isLoading}
          disabled={isLoading}
          className={className}
          onClick={() => {
            inputRefValue.current?.click()
          }}
          {...props}
        >
          {children}
        </Button>
      </FormLabel>
      <input
        type="file"
        id={id}
        accept={acceptedFileTypes}
        ref={inputRefValue}
        name={name}
        disabled={isLoading}
        onChange={onFileChange}
        style={{ display: 'none' }}
        {...inputProps}
      />
    </FormControl>
  )
}

export default FileUploader
